import Logo from "@/assets/icons/logo.svg?react";
import { Box, CssBaseline, Link, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { RequestResetForm } from "../request-reset-form";
import { VerifyCodeForm } from "../verify-code-form";
import { SetPasswordForm } from "../set-password-form";
import { useForgotPassword } from "../../queries";

enum PasswordResetStep {
  REQUEST_RESET = 1,
  VERIFY_CODE = 2,
  SET_PASSWORD = 3,
}

const PasswordResetPage: FC = () => {

  const [currentStep, setCurrentStep] = useState<PasswordResetStep>(PasswordResetStep.REQUEST_RESET);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");

  const { forgotPassword } = useForgotPassword();

  useEffect(() => {
    setCurrentStep(PasswordResetStep.REQUEST_RESET);
  }, []);


  const handleRequestResetComplete = (userEmail: string) => {
    setEmail(userEmail);
    setCurrentStep(PasswordResetStep.VERIFY_CODE);
  };

  const handleVerifyCodeComplete = (verificationCode: string) => {
    setCode(verificationCode);
    setCurrentStep(PasswordResetStep.SET_PASSWORD);
  };

  const handleResendCode = () => {
    forgotPassword({ email });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        p: 2,
        pt: 20,
        alignItems: "center",
        margin: "0 auto",
        maxWidth: "500px",
      }}
    >
      <CssBaseline />
      <Logo width={"100%"} />

      {/* Step 1: Request Reset */}
      {currentStep === PasswordResetStep.REQUEST_RESET && (
        <RequestResetForm onComplete={handleRequestResetComplete} />
      )}

      {/* Step 2: Verify Code */}
      {currentStep === PasswordResetStep.VERIFY_CODE && (
        <VerifyCodeForm
          email={email}
          onComplete={handleVerifyCodeComplete}
          onResend={handleResendCode}
        />
      )}

      {/* Step 3: Set New Password */}
      {currentStep === PasswordResetStep.SET_PASSWORD && (
        <SetPasswordForm
          email={email}
          code={code}
        />
      )}

      <Box
        sx={{
          position: "absolute",
          left: 0,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          bottom: 10,
        }}
      >
        <Typography variant="body2" align="center">
          © 2024 Société.&nbsp;|&nbsp;
          <Link
            href="https://platform.societe.app/terms-and-privacy"
            color="inherit"
            underline="hover"
            target="_blank"
          >
            Privacy Policy
          </Link>{" "}
          &nbsp;|&nbsp;
          <Link
            href="https://platform.societe.app/terms-of-use"
            color="inherit"
            underline="hover"
            target="_blank"
          >
            Terms Of Use
          </Link>{" "}
          &nbsp;|&nbsp;
          <Link
            href="mailto:info@societe.com"
            underline="hover"
            target="_blank"
          >
            info@societe.com
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export { PasswordResetPage };
